import { useState } from "react";
import { Link } from "react-router-dom";
import '../../styles/App.css';

function Navbar({ loggedIn, onLogout }) {
    const logged = localStorage.getItem("userId");
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <nav className="navbar">
            <h1 className="logo">
                <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                    TRADI<span className="logo-highlight">WORLD</span>
                </Link>
            </h1>

            <button
                className="hamburger-btn"
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Toggle menu"
            >
                {menuOpen ? '✕' : '☰'}
            </button>

        <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
        {logged ? (
          <>
            <Link to="/globus" className="nav-link" onClick={() => setMenuOpen(false)}>
              Odkrywaj
            </Link>
            <Link 
              to="/" 
              className="nav-link" 
              onClick={() => {
                onLogout();
                setMenuOpen(false);
              }}
            >
              Wyloguj
            </Link>
            <Link to="/moje-konto" className="nav-link" onClick={() => setMenuOpen(false)}>
              Moje konto
            </Link>
          </>
        ) : (
          <>
            <Link to="/logowanie" className="nav-link" onClick={() => setMenuOpen(false)}>
              Zaloguj
            </Link>
            <Link to="/rejestracja" className="nav-link" onClick={() => setMenuOpen(false)}>
              Zarejestruj
            </Link>
          </>
        )}
      </div>
        </nav>
    )
}

export default Navbar;